var map = {
	"./avatar-1.png": "467a",
	"./avatar-10.png": "2f6a",
	"./avatar-11.png": "6256",
	"./avatar-2.png": "1ee9",
	"./avatar-3.png": "924e",
	"./avatar-4.png": "64d5",
	"./avatar-5.png": "ce88",
	"./avatar-6.png": "0821",
	"./avatar-7.png": "46c0",
	"./avatar-8.png": "d436",
	"./avatar-9.png": "cd9f",
	"./default.png": "5b80",
	"./placeholder-1.png": "d4cd",
	"./placeholder-2.png": "ec29"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a0fc";